/* ===== CHRISTMAS FREE GIFT =====
   After every basket change this asks the theme (sections/xmas-gift-status)
   how much has been spent on Christmas items, then:
   - adds the gift once the spend reaches the threshold, marked with a hidden
     _xmas_gift label
   - removes that marked gift if the spend drops back below
   - updates the "Spend £X more" wording on the product page
   A gift the customer added themselves (no label) is never touched.
   Works alongside Warehouse's own cart code without changing it. */
(function () {
  if (window.__xmasGiftInstalled) return;
  window.__xmasGiftInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'xmas-gift-status';
  var GIFT_PROP = '_xmas_gift';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var queue = Promise.resolve();

  function post(path, data) {
    return originalFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: JSON_HEADERS,
      body: JSON.stringify(data)
    });
  }

  function getCart() {
    return originalFetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function getStatus() {
    return originalFetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data[SECTION] || '', 'text/html');
        var el = doc.querySelector('[data-xmas-gift-status]');
        return el ? JSON.parse(el.textContent) : null;
      });
  }

  function showMessage(status) {
    var els = document.querySelectorAll('[data-xmas-gift-message]');
    for (var i = 0; i < els.length; i++) els[i].textContent = status.message;
  }

  function isTagged(item) {
    return !!(item.properties && item.properties[GIFT_PROP]);
  }

  /* Sets every labelled gift line to the given quantity (0 removes it).
     Resolves with the last cart response, or null if nothing changed. */
  function setTagged(quantity, extra, lastRes, guard) {
    guard = guard || 0;
    if (guard > 4) return Promise.resolve(lastRes || null);
    return getCart().then(function (cart) {
      var target = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (isTagged(cart.items[i]) && cart.items[i].quantity !== quantity) { target = cart.items[i]; break; }
      }
      if (!target) return lastRes || null;
      return post('cart/change.js', Object.assign({ id: target.key, quantity: quantity }, extra))
        .then(function (res) {
          if (!res.ok) return lastRes || null;
          return setTagged(quantity, extra, res, guard + 1);
        });
    });
  }

  function addGift(status, extra) {
    var props = {};
    props[GIFT_PROP] = 'yes';
    return post('cart/add.js', { items: [{ id: Number(status.gift), quantity: 1, properties: props }] })
      .then(function (res) {
        if (!res.ok) return null;
        /* a change request with no real change, so the drawer gets a full basket back */
        return getCart().then(function (cart) {
          if (!cart.items.length) return null;
          return post('cart/change.js', Object.assign({ line: 1, quantity: cart.items[0].quantity }, extra));
        });
      });
  }

  /* Brings the basket in line with the offer.
     Resolves with a cart response if it changed anything, otherwise null. */
  function sync(extra) {
    extra = extra || {};
    return getStatus().then(function (status) {
      if (!status) return null;
      showMessage(status);

      if (!status.gift || !status.unlocked) {
        return status.tagged > 0 ? setTagged(0, extra) : null;
      }
      if (status.tagged > 1) return setTagged(1, extra);
      if (status.tagged === 0 && !status.giftInCart) return addGift(status, extra);
      return null;
    }).catch(function () { return null; });
  }

  function queued(extra) {
    queue = queue.then(function () { return sync(extra); }, function () { return sync(extra); });
    return queue;
  }

  /* ---------- Watching Warehouse's cart requests ---------- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isChange = /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);
    if (!isAdd && !isChange) return originalFetch(input, init);

    var extra = {};
    if (init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        if (body.sections) extra.sections = body.sections;
        if (body.sections_url) extra.sections_url = body.sections_url;
      } catch (e) {}
    }

    return originalFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return queued(isChange ? extra : {}).then(function (fixed) {
        return isChange && fixed ? fixed : response;
      });
    });
  };

  /* ---------- On page load: catch anything that changed without a request above ---------- */
  function onLoad() {
    queued({}).then(function (fixed) {
      if (!fixed) return;
      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();
/* ===== END CHRISTMAS FREE GIFT ===== */
